import script from "./AddNote.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddNote.vue?vue&type=script&lang=ts&setup=true"

import "./AddNote.vue?vue&type=style&index=0&id=6e55c2a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e55c2a8"]])

export default __exports__